@if (!editMode) {
  <div [ngClass]="{ 'align-right': this.fieldConfig.alignRight }" class="form-field-container">
    <span [attr.data-id]="fieldConfig.name + '_' + formattedNumber"
      >{{ formattedNumber }} {{ fieldConfig.suffix }}</span
    >
    @if (showClipboard) {
      <mat-icon
        matSuffix
        class="clipboard-copy"
        [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
        matTooltip="Copy to clipboard"
        (click)="copyToClipboard()"
        >file_copy</mat-icon
      >
    }
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width number-form-field">
    <input
      type="{{ getType() }}"
      formControlName="{{ fieldConfig.name }}"
      [attr.data-id]="'fieldConfigInput_' + fieldConfig.name"
      matInput
      #field
      [errorStateMatcher]="matcher" />
    @for (v of fieldConfig.validators; track v) {
      <mat-error>
        @if (condition(v)) {
          <span>{{ message(v) }}</span>
        }
      </mat-error>
    }
  </mat-form-field>
}
